import { render, staticRenderFns } from "./GendecPage.vue?vue&type=template&id=a2bd0210&scoped=true"
import script from "./GendecPage.vue?vue&type=script&lang=js"
export * from "./GendecPage.vue?vue&type=script&lang=js"
import style0 from "./GendecPage.vue?vue&type=style&index=0&id=a2bd0210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd0210",
  null
  
)

export default component.exports